import { useEffect } from 'react';

import SalesStatementKlokFilters from '~/components/molecules/SalesStatement/SalesStatementKlokFilters';
import SalesStatementKlokHeader from '~/components/molecules/SalesStatement/SalesStatementKlokHeader';

import { PageContainer } from '~/components/bosons/PageContainer.styled';
import SalesStatementKlokCardsPanel from '~/components/molecules/SalesStatement/SalesStatementKlokCardsPanel';
import SalesStatementKlokSummary from '~/components/molecules/SalesStatement/SalesStatementKlokSummary';
import SalesStatementKlokTable from '~/components/molecules/SalesStatement/SalesStatementKlokTable';
import useSalesStatementByTypeStore from '~/zustand/salesStatement/useSalesStatementByTypeStore';

export default function Klok() {
  const resetStates = useSalesStatementByTypeStore(state => state.resetStatesToDefault);

  useEffect(() => {
    return () => {
      function resetStatesWhenCloseTab() {
        resetStates();
      }
      resetStatesWhenCloseTab();
    };
  }, [resetStates]);

  return (
    <PageContainer>
      <SalesStatementKlokHeader />
      <SalesStatementKlokFilters />
      <SalesStatementKlokCardsPanel />
      <SalesStatementKlokTable />
      <SalesStatementKlokSummary />
    </PageContainer>
  );
}
